export const terms = {
  "header": {
    "badge": "Informazioni legali",
    "title": "Termini di utilizzo"
  },
  "content": {
    "intro": "Benvenuti in DONKEY TRAVEL. Le presenti condizioni d'uso regolano l'accesso e l'utilizzo della nostra piattaforma di scambio di alloggi. Utilizzando i nostri servizi, accetti integralmente questi termini.",
    "eligibility": {
      "title": "1. Idoneità e registrazione",
      "text": "L'accesso al club DONKEY TRAVEL è strettamente riservato agli host con un annuncio attivo su piattaforme riconosciute (come Airbnb) con una valutazione complessiva minima di 4,5 su 5. Qualsiasi falsificazione di questi criteri comporterà l'immediata cancellazione dell'account senza rimborso dell'abbonamento."
    },
    "subscription": {
      "title": "2. Abbonamento e pagamenti",
      "text": "Il pieno utilizzo della piattaforma richiede l'abbonamento a uno dei nostri pacchetti (mensile, annuale o Club+). I pagamenti sono sicuri ed elaborati da fornitori terzi. L'abbonamento è tacitamente rinnovabile salvo disdetta da parte dell'utente."
    },
    "exchanges": {
      "title": "3. Come funzionano gli scambi",
      "text": "Gli scambi all’interno del club si basano sulla fiducia e sul rispetto reciproco. Gli accordi di scambio vengono stipulati direttamente tra i membri tramite la nostra messaggistica interna. Tra le due parti viene concluso un contratto di scambio morale ed eventualmente legale."
    },
    "responsibilities": {
      "title": "4. Impegni e responsabilità",
      "text": "Ogni membro si impegna a presentare il proprio alloggio in maniera trasparente, con foto recenti e descrizioni accurate. Il membro ospitante garantisce l'igiene impeccabile del luogo. Il membro ospite si impegna a rispettare scrupolosamente l'alloggio ed il suo regolamento interno. DONKEY TRAVEL agisce come facilitatore e non è parte dei contratti di scambio tra i membri. Non ci assumiamo alcuna responsabilità per danni, contestazioni o cancellazioni last minute, anche se possiamo intervenire in mediazione."
    },
    "termination": {
      "title": "5. Sospensione e risoluzione",
      "text": "DONKEY TRAVEL si riserva il diritto di sospendere o bannare qualsiasi membro che non rispetti le regole di buona condotta della community, accumuli feedback negativi o violi queste condizioni, unilateralmente."
    },
    "contact": {
      "title": "6. Legge applicabile e controversie",
      "text": "Queste condizioni sono regolate dalla legge francese. In caso di disaccordo, le parti si impegnano a ricercare una soluzione amichevole prima di qualsiasi azione legale davanti ai tribunali competenti. Per qualsiasi domanda, contattaci a legal@donkey.travel."
    }
  }
};
